/**
 *  Converts a string into Capitalize
 * 
 * 'abc' => 'Abc'
 */

function capitalize (value) {
  if (!value && value !== 0) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export default capitalize



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue2-filters/src/string/capitalize.js
// module id = Jsmg
// module chunks = 34